import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]

  connect() {
    console.log("CSV Preview Manual Input Controller connected")
  }

  validate(event) {
    // Find the textarea directly
    let textarea
    try {
      textarea = this.contentTarget
    } catch (e) {
      textarea = this.element.querySelector('textarea[name="generic_file_import[content]"]')
    }
    
    if (!textarea || !textarea.value.trim()) {
      event.preventDefault()
      this.showError('Content cannot be blank')
      
      // Disable the submit button
      const submitButton = this.element.querySelector('input[type="submit"], button[type="submit"]')
      if (submitButton) {
        submitButton.disabled = true
      }
      
      // Focus the textarea if it exists
      if (textarea) {
        textarea.focus()
        
        // Add input event listener to re-enable the button when user types
        textarea.addEventListener('input', this.checkContent.bind(this))
      }
    }
  }
  
  checkContent() {
    // Find the textarea and submit button
    let textarea
    try {
      textarea = this.contentTarget
    } catch (e) {
      textarea = this.element.querySelector('textarea[name="generic_file_import[content]"]')
    }
    const submitButton = this.element.querySelector('input[type="submit"], button[type="submit"]')
    
    // If content is not empty, enable the button and remove error message
    if (textarea && textarea.value.trim() && submitButton) {
      submitButton.disabled = false
      
      // Remove any existing error messages
      const existingError = this.element.querySelector('.manual-input-error')
      if (existingError) {
        existingError.remove()
      }
    }
  }

  showError(message) {
    // Remove any existing error messages
    const existingError = this.element.querySelector('.manual-input-error')
    if (existingError) {
      existingError.remove()
    }

    // Create and show the error message
    const errorDiv = document.createElement('div')
    errorDiv.className = 'alert alert-danger mt-2 manual-input-error'
    errorDiv.textContent = message
    
    // Insert at the beginning of the controller element
    this.element.insertBefore(errorDiv, this.element.firstChild)
  }
}
